import useProjectConfiguration from 'common/fetchHooks/useProjectConfiguration';
import EditDeleteMenuButton from './EditDeleteMenuButton';
import { onDelete, onEdit } from '../services/projects.services';

const MenuButton = ({
  project,
  pmSensorAuthId,
  toggleModal,
  toggleSnackBar,
  onSaveClick,
  onDeleteProject,
  deleteCallback
}) => {
  const { deleteProject, deleteFromDB } = useProjectConfiguration({});
  return (
    <EditDeleteMenuButton
      onEdit={() =>
        onEdit({
          toggleModal,
          project,
          onSaveClick,
          pmSensorAuthId
        })
      }
      onDelete={() =>
        onDelete({
          toggleModal,
          toggleSnackBar,
          project,
          onDeleteProject,
          deleteProject,
          deleteCallback,
          deleteFromDB
        })
      }
    />
  );
};

export default MenuButton;
